import * as React from "react";

function TextButton() {
  return (
<svg xmlns="http://www.w3.org/2000/svg" width="46" height="11" viewBox="0 0 46 11">
  <text id="Text_Button" data-name="Text Button" transform="translate(23 9)" fill="#2067ed" font-size="8" font-family="OpenSans-Semibold, Open Sans" font-weight="600"><tspan x="-22.33" y="0">Text Button</tspan></text>
</svg>

);
}

export default TextButton;

